export default __webpack_public_path__ + "static/media/aumtro.b88bee03.png";